import * as React from 'react'

function SvgHn(props) {
	return (
		<svg viewBox="0 0 72 36" width="1em" height="1em" {...props}>
			<path fill="#0073cf" d="M0 0h72v36H0z" />
			<path fill="#fff" d="M0 12h72v12H0z" />
			<g id="hn_svg__c" transform="matrix(2 0 0 2 36 18)" fill="#0073cf">
				<g id="hn_svg__b">
					<path id="hn_svg__a" transform="rotate(18 3.157 -.5)" d="M0 0v1h.5z" />
					<use xlinkHref="#hn_svg__a" transform="scale(-1 1)" />
				</g>
				<use xlinkHref="#hn_svg__b" transform="rotate(72)" />
				<use xlinkHref="#hn_svg__b" transform="rotate(-72)" />
				<use xlinkHref="#hn_svg__b" transform="rotate(144)" />
				<use xlinkHref="#hn_svg__b" transform="rotate(-144)" />
			</g>
			<use xlinkHref="#hn_svg__c" transform="translate(10 -3.2)" />
			<use xlinkHref="#hn_svg__c" transform="translate(10 2.8)" />
			<use xlinkHref="#hn_svg__c" transform="translate(-10 -3.2)" />
			<use xlinkHref="#hn_svg__c" transform="translate(-10 2.8)" />
		</svg>
	)
}

export default SvgHn
